import { afterNextRender, ChangeDetectionStrategy, Component, effect, input, model, signal } from '@angular/core';
import { UCustomSize, UTypeElement, UTypeSizeElement, UTypeStateElement } from '../types/types';
import { isEmpty } from 'lodash';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class UBaseInfraComponent {
  readonly ICON_CLASS = 'font-icon icon-';
  styleClass = signal<string>(null);

  typeElement = model<UTypeElement>('secondary');
  stateElement = model<UTypeStateElement>('regular');
  sizeElement = input<UTypeSizeElement>('medium');
  customSize = input<UCustomSize>();
  iconStyles = input<any>({});

  constructor() {
    effect(
      () => {
        if (this.sizeElement() || this.stateElement()) {
          this.setStyleClass();
        }
        if (this.iconStyles()) {
          this.setIconStyles();
        }
      },
      { allowSignalWrites: true }
    );
    afterNextRender(() => {
      if (!this.sizeElement() && !this.stateElement()) {
        this.setStyleClass();
      }
    });
  }

  abstract getIconRef(): any;

  getBaseClasses(): any {
    return {
      'u-element-hover': this.stateElement() === 'hover',
      'u-element-active': this.stateElement() === 'active',
      'u-element-focus': this.stateElement() === 'focus',
      'u-element-loading': this.stateElement() === 'loading',
      'u-element-disabled': this.stateElement() === 'disabled',
      'u-element-readonly': this.stateElement() === 'readonly',
      'u-element-error': this.stateElement() === 'error',
      'u-element-xs': this.sizeElement() === 'extra-small',
      'u-element-sm': this.sizeElement() === 'small',
      'u-element-md': this.sizeElement() === 'medium',
      'u-element-lg': this.sizeElement() === 'large',
      'u-element-xl': this.sizeElement() === 'extra-large',
      'u-element-primary': this.typeElement() === 'primary',
      'u-element-secondary': this.typeElement() === 'secondary',
      'u-element-danger': this.typeElement() === 'danger',
      'u-element-success': this.typeElement() === 'success',
    };
  }

  setStyleClass() {
    const classes = this.getBaseClasses();

    this.styleClass.set(
      Object.keys(classes)
        .filter((key) => classes[key])
        .join(' ')
    );
  }

  private setIconStyles() {
    const iconRef = this.getIconRef();
    if (!iconRef) {
      return;
    }
    if (isEmpty(this.iconStyles())) {
      iconRef.removeAttribute('style');
    } else {
      Object.keys(this.iconStyles()).forEach((key) => {
        iconRef.style[key] = this.iconStyles()[key];
      });
    }
  }
}
